export type CashierPaymentStatusOrder = {
  status: string
  statusText?: string
  offlineConfirmedByName?: string
  offlineConfirmedAt?: string
}

export type CashierPaymentStatusView = {
  title: string
  detail: string
}

export function cashierPaymentStatus(order: CashierPaymentStatusOrder): CashierPaymentStatusView {
  const status = order.status.trim().toUpperCase()
  if (status === 'PAID') {
    return {
      title: order.offlineConfirmedByName?.trim() || '已确认收款',
      detail: order.offlineConfirmedAt?.trim() || ''
    }
  }
  if (status === 'REFUNDED') {
    return { title: '已退款', detail: order.statusText?.trim() || '订单已退款' }
  }
  return {
    title: '未收款',
    detail: order.statusText?.trim() || (status === 'CANCELLED' ? '订单已取消' : order.status)
  }
}
